<template>
    <div class="activeBox">
        <input type="checkbox"
               :disabled="isDisabled"
               :id="uniqueId"
               :checked="isActive"
               @change="changed"/>
        <span @click="clickHandle" class="icon-wrap">
            <IconBase :width="iconWidth"
                      :height="iconHeight"
                      :iconName="activeSwitcherIcon"
                      :iconColor="iconColor"
                      verticalAlign="middle"
                      key="active"
                      :display="iconDisplay"
                      v-if="isActive && !abSwitcher && !adunitLiveSwitcher"/>
            <IconBase :width="iconWidth"
                      :height="iconHeight"
                      :iconName="inactiveSwitcherIcon"
                      :iconColor="iconColor"
                      verticalAlign="middle"
                      key="inactive"
                      :display="iconDisplay"
                      v-if="!isActive && !abSwitcher && !adunitLiveSwitcher"/>
            <IconBase width="40" height="16" iconName="switcherADisabledIcon"
                      v-if="isActive && abSwitcher && isDisabled"
                      key="activeDisabledAB"
                      verticalAlign="middle"
                      :display="iconDisplay"
            />
            <IconBase width="40" height="16" iconName="switcherBDisabledIcon"
                      v-if="!isActive && abSwitcher && isDisabled"
                      verticalAlign="middle"
                      key="inactiveDisabledAB"
                      :display="iconDisplay"
            />
            <IconBase width="40" height="16" iconName="switcherAIcon"
                      v-if="isActive && abSwitcher && !isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="activeAB"
            />
            <IconBase width="40" height="16" iconName="switcherBIcon"
                      v-if="!isActive && abSwitcher && !isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="inactiveAB"
            />
            <IconBase width="55" height="24" iconName="switcherLiveAdUnitIcon"
                      v-if="isActive && adunitLiveSwitcher && !isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="activeAdunits"
            />
            <IconBase width="55" height="24" iconName="switcherNotLiveAdUnitIcon"
                      v-if="!isActive && adunitLiveSwitcher && !isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="inactiveAdUnits"
            />
            <IconBase width="55" height="24" iconName="switcherDisabledAdUnitIcon"
                      v-if="!isActive && adunitLiveSwitcher && isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="inactiveAdUnitsDisabled"
            />
            <IconBase width="55" height="24" iconName="switcherDisabledAdUnitIcon"
                      v-if="isActive && adunitLiveSwitcher && isDisabled"
                      verticalAlign="middle"
                      :display="iconDisplay"
                      key="activeAdUnitsDisabled"
            />
        </span>
        <label :for="uniqueId" class="inputText ng-animate-disabled"
               v-if="text || textInactive" :class="{'smallLabel': smallLabel}">
            {{ !isActive ? textInactiveComputed : text }}
        </label>
    </div>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from './IconBase.vue';

const Colors = {
    orange: 'orange'
};
const Looks = {
    AB: 'ab',
    adunitLiveSwitcher: 'adunitLiveSwitcher'
};
const Labels = {
    small: 'small'
};
const WidthSizes = {
    normal: '25',
    small: '22'
};
const HeightSizes = {
    normal: '15',
    small: '14'
};
const props = {
    uniqueId: String,
    isActive: {
        type: Boolean,
        default: false
    },
    isDisabled: {
        type: Boolean,
        default: false
    },
    activeSwitcherIcon: {
        type: String,
        default: 'activeSwitcherIcon'
    },
    inactiveSwitcherIcon: {
        type: String,
        default: 'inactiveSwitcherIcon'
    },
    styles: {
        type: Object,
        default() {
            return {
                label: '',
                color: '',
                look: '',
                size: 'normal'
            };
        },
        validator(value) {
            let valid = true;
            if (value) {
                if (value.label) {
                    valid = Object.values(Labels).indexOf(value.label) !== -1;
                }
                if (valid && value.color) {
                    valid = Object.values(Colors).indexOf(value.color) !== -1;
                }
                if (valid && value.look) {
                    valid = Object.values(Looks).indexOf(value.look) !== -1;
                }
                if (valid && value.size) {
                    valid = WidthSizes[value.size] !== undefined;
                }
            }
            return valid;
        }
    },
    // eslint-disable-next-line max-len
    text: String, // text - if textInactive is "undefined", text attribute will shown in both active&inactive statuses
    textInactive: String, // text only for inactive mode,
    iconDisplay: {
        type: String,
        default: 'inline-block'
    }
};

export default {
    name: 'Switcher',
    components: {
        IconBase
    },
    props,
    computed: {
        orangeSwitcher() {
            return (this.styles && this.styles.color === Colors.orange) || false;
        },
        abSwitcher() {
            return (this.styles && this.styles.look === Looks.AB) || false;
        },
        adunitLiveSwitcher() {
            return (this.styles && this.styles.look === Looks.adunitLiveSwitcher) || false;
        },
        smallLabel() {
            return (this.styles && this.styles.label === Labels.small) || false;
        },
        textInactiveComputed() {
            return this.textInactive ? this.textInactive : this.text;
        },
        iconColor() {
            switch (true) {
            case this.isActive && !this.isDisabled:
                if (this.orangeSwitcher) {
                    return consts.COLORS.NEUTRAL_700;
                }
                return consts.COLORS.POSITIVE_500;
            case !this.isActive && !this.isDisabled:
                return consts.COLORS.SWITCHER_OFF;
            case this.isActive && this.isDisabled:
                return consts.COLORS.SWITCHER_ON_DISABLED;
            case !this.isActive && this.isDisabled:
                return consts.COLORS.LIGHT_500;
            default:
                break;
            }
            return 'currentColor';
        },
        iconWidth() {
            return (this.styles && this.styles.size)
                ? WidthSizes[this.styles.size] : WidthSizes.normal;
        },
        iconHeight() {
            return (this.styles && this.styles.size)
                ? HeightSizes[this.styles.size] : HeightSizes.normal;
        }
    },
    methods: {
        changed() {
            if (this.isDisabled) return;
            this.$emit('changed', !this.isActive);
        },
        clickHandle() {
            if (this.isDisabled) return;
            this.$emit('changed', !this.isActive);
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    .activeBox{
        white-space: nowrap;
        display: inline-block;
        -webkit-user-select: none;
        -ms-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;

        &>span{
            cursor: pointer;
        }
        input[type='checkbox']{
            display:none;

            & ~ label.inputText {
                @include font(7);
                color: $dark-300;
                cursor: pointer;
                display: inline-block;
                line-height: 18px;
                vertical-align: middle;
                padding-left: 10px;
                &.smallLabel {
                    @include font(5);
                }
            }
            &:disabled ~ label.inputText{
                color: $disabledText;
                cursor: default;
            }

            &:disabled + span{
                cursor: default;
            }
        }
    }

    .icon-wrap {
        vertical-align: inherit;
    }
</style>
